export default __webpack_public_path__ + "static/media/cheetah.45de5798.jpeg";